const BookingReducer = (state: any, action: any) => {
  switch (action.type) {
    case "SAVE_BOOKING":
      return {
        ...state,
        loading: false,
        bookingInfo: action.payload,
      };
    case "SAVE_PAYMENT":
      return {
        ...state,
        loading: false,
        paymentState: action.payload,
      };
    case "SAVE_INFO_AFTER_PURCHASE":
      return {
        ...state,
        bookingInfoAfterPurchase: action.payload,
      };
    default:
      return state;
  }
};

export default BookingReducer;
